export default "__VITE_ASSET__BxNxc8Qq__"